<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">World Region Territory ({{ this.rules.name }})</span>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text>
        <v-col cols="4" sm="2" md="2">
          <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
        </v-col>
        <v-row dense>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label=" Region Territory:" v-model.number="model.regionTerritory" hide-details/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-checkbox v-model="model.autoOpen" label="Auto Open" class="mt-3" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <v-text-field label="Key:" v-model.trim="model.key" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="12" sm="12"/>
        </v-row>
        <v-expansion-panels>
          <r-currency-panel :items.sync="model.money" title="Currency"/>
          <r-item-panel :items.sync="model.items" title="Items"/>
          <r-trigger-panel :items.sync="model.triggers" title="Triggers"/>
          <r-search-panel :items.sync="model.searches" title="Searches"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {WorldRegionTerritory} from "@/modules/redactor/models/world-region/WorldRegionTerritory";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RAuthorize from "@/modules/redactor/views/common/r-authorize";
import RCurrencyPanel from "@/modules/redactor/views/currency/r-currency-panel.vue";
import RTriggerPanel from "@/modules/redactor/views/trigger/r-trigger-panel.vue";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";
import RItemPanel from "@/modules/redactor/views/item/r-item-panel.vue";
import RSearchPanel from "@/modules/redactor/views/search/r-search-panel.vue";


export default {
  name: "r-world-region-territory-dialog",
  components: {RPreviewDialog, RTriggerPanel, RCurrencyPanel, RAuthorize, RItemPanel, RSearchPanel },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new WorldRegionTerritory(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorldRegionTerritory();

      if (ViewRules.COPY.equal(this.rules)) {
        this.model.locked = false;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      // Check basic validation first
      if (!this.model.valid()) {
        this.$alert("Invalid config!");
        return;
      }
      
      // Check for unique regionTerritory
      const allRegions = RedactorUtils.getWorldRegionTerritories();
      const duplicates = allRegions.filter(otherItem => 
        otherItem.uid !== this.model.uid && 
        otherItem.regionTerritory === this.model.regionTerritory
      );
      
      if (duplicates.length > 0) {
        this.$alert(`Region Territory ID ${this.model.regionTerritory} is already used by another item. Each region territory must have a unique ID.`);
        return;
      }
      
      this.resolve(this.model);
      this.discard();
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, WorldRegionTerritory)
        .then((result) => {
          Object.assign(this.model, result);
        })
        .catch((e) => {
          this.$alert("Failed to parse config!" + e.message);
        });
    }
  }
}
</script>